import { useEffect } from "react";

import { useAppContext } from "./useAppContext";

/**
 * Subscribe for messages and unsubscribe on unmount.
 * Remark: This is called synchroniously and React state is async, so be carefull to combine with react state that still has the previous value
 * @param onMessage handler for new messages
 * @param options.captureInteractiveMessages default false, pass true to also get the interactive messages
 */
export function useMessage(
	onMessage: (message: eXpress.core.IMessage) => void,
	options: { captureInteractiveMessages?: boolean } = {},
) {
	const {
		editor: { broadcaster },
	} = useAppContext();
	const { captureInteractiveMessages = false } = options;

	useEffect(() => {
		// Subscribe
		const disposable = broadcaster.subscribe(
			{
				messageHandler(message) {
					onMessage(message);
				},
			},
			captureInteractiveMessages
				? eXpress.core.ListenerFlags.Interactive
				: eXpress.core.ListenerFlags.None,
		);

		// Unsubscribe on unmount
		return () => {
			disposable.dispose();
		};
	}, [broadcaster, captureInteractiveMessages, onMessage]);
}
